export const xlsxTypes = {
  SET_XLSX: 'SET_XLSX',
  SET_XML: 'SET_XML',
  SET_ALL_XML_STATUS: 'SET_ALL_XML_STATUS',
  RESET_XLSX_STATE: 'RESET_XLSX_STATE',
}